module.exports = __webpack_public_path__ + "static/spacing-5.7bb399a7.svg";